import React, { createRef } from "react";
import {
  Select,
  Checkbox,
  Table,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CashierCollectionReportStore from "../store/CashierCollectionReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import conf from "../config";
import { EyeOutlined } from "@ant-design/icons";

const { Option } = Select;
const { RangePicker } = DatePicker;

const tripColumns = [
  {
    title: "Trip No",
    dataIndex: "tripNo",
    key: "tripNo",
  },
  {
    title: "Trip Start Time",
    dataIndex: "tripStartTime",
    key: "tripStartTime",
  },
  {
    title: "Trip Type",
    dataIndex: "tripTypeDesc",
    key: "tripTypeDesc",
  },
  {
    title: "Distance (Km)",
    dataIndex: "hiredDistanceKm",
    key: "hiredDistanceKm",
  },
  {
    title: "Fare",
    dataIndex: "totalFare",
    key: "totalFare",
  },
  {
    title: "Status",
    dataIndex: "tripStatus",
    key: "tripStatus",
  },
  {
    title: "Proof",
    dataIndex: "proof",
    key: "proof",
    render: (name) => {
      if (!name) return "-";

      return (
        <a
          href="#"
          onClick={async (e) => {
            e.preventDefault();

            const imageUrl = `${conf.oldWebSAUrl}/images/users/${name}`;

            const response = await fetch(imageUrl);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
          }}
        >
          Download
        </a>
      );
    },
  }
];

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    // console.log(val.title.length)
  });

  return arr;
};
class CashierCollectionReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.cashierCollectionReportStore = new CashierCollectionReportStore();
  

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedUsers: [],
      selectedcashierInnerGridData: [],
      selectAllUsers: false,
      showMonthPopup: false,
      selectAllcashierInnerGridData: false,
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notuser: false,
      user: false,
      expandedRowKeys: [],
      loadedSummaryData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      toDateNotSelected: false,
      fromDateNotSelected: false,
      Notdate: false,
      tripModal: false,
      tripData: [],
      tripLoading: false,
      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_COMPANY_NAME_"),
          dataIndex: "companyName",
          key: "companyName",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_CASHIER_NAME_"),
          dataIndex: "userName",
          key: "userName",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_TOTAL_TRIPS_"),
          dataIndex: "totalTrips",
          key: "totalTrips",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_TOTAL_AMOUNT_"),
          dataIndex: "totalAmount",
          key: "totalAmount",
          width: 100,
          ellipsis: { showTitle: true },
        }
      ]),
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            loginUserId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            companyId: this.state.companyId,
            userId: this.state.selectedUsers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            language: "english",
            offset: -1,
            limit: 20
          };
          if (val.key === "excel") {
            await this.cashierCollectionReportStore.exportExcel(getData);
          }
          if (val.key === "pdf") {
            await this.cashierCollectionReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {

    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedUsers: [],
      selectAllUsers: false,
    });

    await this.cashierCollectionReportStore.getCashierUser(comp?.value);

    await this.setState({ loadData: 1 });
  }

  showTripTable = async (record) => {

    this.setState({
      tripModal: true,
      tripData: record.adjustedTripData || [],
    });

    // try {

    //   this.setState({
    //     tripLoading: true,
    //     tripModal: true,
    //   });

    //   const res = await this.cashierCollectionReportStore.getAdjustedTrips({
    //     shiftId: record.shiftId,
    //     userId: record.userId,
    //     driverId: record.driverId,
    //     companyId: this.state.companyId,
    //   });

    //   this.setState({
    //     tripData: res || [],
    //     tripLoading: false,
    //   });

    // } catch (err) {
    //   this.setState({
    //     tripLoading: false,
    //     tripData: [],
    //   });
    // }
  };

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;
    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  showData = async () => {

    this.setState({ expandedRowKeys: [] });

    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedUsers.length === 0) {
      this.setState({ Notuser: true });
    } else {
      this.setState({ Notuser: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }

    if (
      this.state.companyId &&
      this.state.selectedUsers.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {

      this.setState({ Notcompany: false, Notuser: false, user: false });

      if (this.checkFromDate(this.state.fromDate)) {
        await this.cashierCollectionReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          userId: this.state.selectedUsers,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" })
    }
  };

  handleAllSelectUsers = async (e) => {
    console.log("e",e,"selectAllUsers",this.state.selectAllUsers)
    if (this.state.selectAllUsers) {
      
      const allUsers = this.cashierCollectionReportStore?.getUsersUsingCompanyId?.map(
        (val) => {
          return val.userId;
        }
      );
      await this.setState({ selectedUsers: allUsers });
    } else {
      await this.setState({ selectedUsers: [] });
    }
  };

  onExpand = async (expanded, record) => {
   
    this.setState({
      expandedRowKeys: expanded ? [record.row_id] : [],
    });

  };

  handleExpandRow = async (record) => {
    
    const innerGridData = record?.tableData || [];

    this.setState((prev) => ({
      innerGridData,
      loadedSummaryData: {
        ...prev.loadedSummaryData,
        [record.row_id]: true,
      },
    }));
  };

  getExpandedColumns = () => {
    const { filterValue } = this.state;

    const allColumns = [
      {
        title: this.context.translate("_SHIFT_NUMBER_"),
        dataIndex: "shiftNo",
        key: "shiftNo",
        width: "10%",
      },
      {
        title: this.context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"),
        dataIndex: "driverName",
        key: "driverName",
        width: "10%",
      },
      {
        title: this.context.translate("_SHIFT_START_TIME_"),
        dataIndex: "shiftStartTime",
        key: "shiftStartTime",
        width: "10%",
      },
      {
        title: this.context.translate("_SHIFT_END_TIME_"),
        dataIndex: "shiftEndTime",
        key: "shiftEndTime",
        width: "10%",
      },
      {
        title: this.context.translate("_NO_OF_TRIPS_"),
        dataIndex: "trips",
        key: "trips",
        width: "8%",
      },
      {
        title: this.context.translate("_TOTAL_KM_"),
        dataIndex: "totalKm",
        key: "totalKm",
        width: "8%",
      },
      {
        title: this.context.translate("_RECEIVED_CASH_"),
        dataIndex: "receivedCash",
        key: "receivedCash",
        width: "10%",
      },
      {
        title: this.context.translate("_EXPENSES_AMOUNT_"),
        dataIndex: "deductableExpense",
        key: "deductableExpense",
        width: "10%",
      },
      {
        title: this.context.translate("_EXPENSES_"),
        dataIndex: "deductableExpenseProof",
        key: "deductableExpenseProof",
        width: "8%",
        render: (names) => {
          if (!names) return "-";

          const files = names.split(",").map((file) => file.trim());

          return (
            <>
              {files.map((file, index) => (
                <div key={index}>
                  <a
                    href="#"
                    onClick={async (e) => {
                      e.preventDefault();

                      try {
                        const imageUrl = `${conf.oldWebSAUrl}/images/users/${file}`;

                        const response = await fetch(imageUrl);
                        if (!response.ok) {
                          throw new Error("Failed to download file");
                        }

                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);

                        const link = document.createElement("a");
                        link.href = url;
                        link.download = file;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        window.URL.revokeObjectURL(url);
                      } catch (err) {
                        console.error("Download failed:", err);
                      }
                    }}
                  >
                    Expenses {index + 1}
                  </a>
                </div>
              ))}
            </>
          );
        },
      },
      {
        title: this.context.translate("_ADJUSTED_TRIPS_COUNT_"),
        dataIndex: "adjustedTrips",
        key: "adjustedTrips",
        width: "10%",
      },
      {
        title: this.context.translate("_ADJUSTED_AMOUNT_"),
        dataIndex: "adjustedAmount",
        key: "adjustedAmount",
        width: "10%",
      },
      {
        title: this.context.translate("_ADJUSTED_TRIPS_"),
        width: "10%",
        dataIndex: "adjustedTrips",
        key: "adjustedTrips",
        align: "center",
        render: (value, record) =>
          value > 0 ? (
            <Tooltip title="View Trip Details">
              <EyeOutlined
                style={{ color: "#1677ff", cursor: "pointer", fontSize: 18 }}
                onClick={() => this.showTripTable(record)}
              />
            </Tooltip>
          ) : (
            "-"
          ),
      },
    ];

    return allColumns;

  };

  expandedRowRender = (record) => {
    
    const columns = this.getExpandedColumns();

    return (
      <div className="innerGridTbl">
        <Table
          bordered
          size="small"
          rowKey={(row) => `${record.row_id}_${row.inTime}`} // safe unique key
          style={{ padding: "20px 20px 20px 10px" }}
          columns={columns}
          dataSource={record.tableData || []}   // ✅ CORE FIX
          pagination={false}
        />
      </div>
    );

  };

  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  className="searchInput"
                  allowClear={true}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />
              
                <>
                  <Checkbox
                    checked={this.state.selectAllUsers}
                    onChange={async (e) => {
                      await this.setState({
                        selectAllUsers: e.target.checked,
                      });
                      if (this.state.selectAllUsers) {
                        await this.setState({
                          Notuser: false,
                        });
                      }
                      await this.handleAllSelectUsers();
                    }}
                  />

                  {this.context.translate("_ALL_")}

                  <Select
                    maxTagCount="responsive"
                    className="searchInput"
                    value={this.state.selectedUsers}
                    onChange={(val) => {
                      this.setState({ selectedUsers: val });
                      if (
                        this.cashierCollectionReportStore?.getUsersUsingCompanyId?.length >
                        val.length
                      ) {
                        this.setState({ selectAllUsers: false });
                      } else {
                        this.setState({ selectAllUsers: true });
                      }

                      if (val?.length > 1) {
                        //   console.log(val?.length > 1);
                        this.setState({ showAlertPopup: true });
                      }
                    }}
                    style={{ width: 180 }}
                    showSearch
                    status={this.state.Notuser ? "error" : false}
                    mode="multiple"
                    placeholder={this.context.translate(
                      "_CASHIER_NAME_"
                    )}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.cashierCollectionReportStore?.getUsersUsingCompanyId?.map(
                      (val) => {
                        return (
                          <Option value={val.userId}>{val.name}</Option>
                        );
                      }
                    )}
                  </Select>
                </>
            
                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  status={this.state.Notdate ? "error" : false}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />

                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.cashierCollectionReportStore?.cashierAllData?.length >
                      0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            rowKey="row_id"
            key={this.state.selectedColumns.length}
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.cashierCollectionReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.cashierCollectionReportStore?.cashierAllData}
            loading={this.cashierCollectionReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>

        <Modal
          title="Adjusted Trips"
          open={this.state.tripModal}
          width={1000}
          footer={null}
          onCancel={() =>
            this.setState({
              tripModal: false,
              tripData: [],
            })
          }
        >
          <Table
            rowKey="tripId"
            loading={this.state.tripLoading}
            columns={tripColumns}
            dataSource={this.state.tripData}
            pagination={false}
          />
        </Modal>

      </>
    );
  }
}
CashierCollectionReport.contextType = StoreContext;
export default observer(withRouter(CashierCollectionReport));
